import "./ContactPage.css";

import ContactForm from "../../components/Froms/ContactFrom/ContactForm";

const ContactPage = () => {
  return (
    <ContactForm />
  );
};

export default ContactPage;
